// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// Components
import Pagination from 'components/Pagination';
import Table from './Table';

import styles from './styles.styl';

const Vendors = React.forwardRef(function(
  { className, page, loadPage, vendors, setPaginationHref, url, ...rest },
  forwardRef,
) {
  return (
    <div ref={forwardRef} className={cn(styles.Vendors, className)}>
      <Table className={styles.Vendors__table} vendors={vendors} url={url} {...rest} />

      <Pagination
        className={styles.Vendors__pagination}
        length={Math.ceil(vendors.total / 5)}
        currentNumber={page}
        setHref={setPaginationHref}
        onClick={loadPage}
      />
    </div>
  );
});

Vendors.displayName = 'Vendors';

Vendors.defaultProps = {
  className: '',
};

Vendors.propTypes = {
  className: PropTypes.string,
  page: PropTypes.number,
  loadPage: PropTypes.func,
  setPaginationHref: PropTypes.func.isRequired,
  vendors: PropTypes.object,
  url: PropTypes.string.isRequired,
};

export default Vendors;
